import {Dispatch} from 'redux';
import {educationAPI} from '../API/api';
import {
	EducationData,
	OneLessonType,
	OneModuleType,
} from '../types/TypesEducation';

const SET_LESSONS_LIST = 'Choice/education_Reducer/SET_LESSONS_LIST';
const SET_MODULE_INFO = 'Choice/education_Reducer/SET_MODULE_INFO';
const SET_SUB_MODULE_LIST = 'Choice/education_Reducer/SET_SUB_MODULE_LIST';
const SET_ONE_LESSON = 'Choice/education_Reducer/SET_ONE_LESSON';
const SET_QUESTIONS = 'Choice/education_Reducer/SET_QUESTIONS';
const SET_STUDY_COMPLETE = 'Choice/education_Reducer/SET_STUDY_COMPLETE';
const SET_FEEDBACK = 'Choice/education_Reducer/SET_FEEDBACK';

const initialState: EducationData = {
	userLessonsList: [],
	userModuleInfo: null,
	userModuleNavigation: [],
	userSubModuleList: [],
	oneLesson: null,
	questions: null,
	textApproveFeedback: null,
};

const education_Reducer = (
	state: EducationData = initialState,
	action: any,
) => {
	switch (action.type) {
		case SET_LESSONS_LIST:
			return {
				...state,
				userLessonsList: action.data,
			};
		case SET_MODULE_INFO:
			return {
				...state,
				userModuleInfo: action.data.info,
				userModuleNavigation: action.data.navigation,
			};
		case SET_SUB_MODULE_LIST:
			const modules = action.data === null ? [] : action.data;
			return {
				...state,
				userSubModuleList: modules,
			};
		case SET_ONE_LESSON:
			return {
				...state,
				oneLesson: action?.data,
			};
		case SET_QUESTIONS:
			return {
				...state,
				questions: action.data,
			};
		case SET_STUDY_COMPLETE:
			return {
				...state,
				oneLesson: {...state.oneLesson, completed: action.data.approve},
			};
		case SET_FEEDBACK:
			return {
				...state,
				textApproveFeedback: action.data,
			};
		default:
			return state;
	}
};

export const setLessonsList = (data: any) => ({type: SET_LESSONS_LIST, data});
export const setModuleInfo = (data: OneModuleType) => ({
	type: SET_MODULE_INFO,
	data,
});
export const setSubModulesList = (data: any) => ({
	type: SET_SUB_MODULE_LIST,
	data,
});
export const setOneLesson = (data: OneLessonType) => ({
	type: SET_ONE_LESSON,
	data,
});
export const setQuestions = (data: any) => ({type: SET_QUESTIONS, data});
export const setStudyComplete = (data: {
	approve: boolean;
	lessonId: number;
}) => ({type: SET_STUDY_COMPLETE, data});
export const setFeedbackApprove = (data: string) => ({
	type: SET_FEEDBACK,
	data,
});

export const getUserLessonsList =
	(module_id: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getLessonsList(module_id);
			if (response.data.approve) {
				if (response.data.lessons) {
					dispatch(setLessonsList(response.data.lessons));
				}
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getUserModuleInfo =
	(module_id: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getModuleInfo(module_id);
			if (response.data.approve) {
				if (response.data) {
					dispatch(setModuleInfo(response.data));
				}
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getUserSubModulesList =
	(module_id: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getSubModuleList(module_id);
			if (response.data.approve) {
				if (response.data) {
					dispatch(setSubModulesList(response.data.modules));
				}
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getOneLesson =
	(lesson_id: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getOneLesson(lesson_id);
			if (response.data.approve) {
				if (response.data && Array.isArray(response.data.lesson)) {
					dispatch(setOneLesson(response?.data?.lesson[0]));
				}
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getQuestions =
	(lesson_id: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getQuestions(lesson_id);
			if (response.data.approve) {
				if (response.data.questions) {
					dispatch(setQuestions(response.data.questions));
				}
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getStudyComplete =
	(data: any, lessonId: number) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getStudyComplete(data, lessonId);
			if (response.data.approve) {
				dispatch(setStudyComplete({approve: response.data.approve, lessonId}));
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};
export const getSendFeedback =
	(feedback: string) => async (dispatch: Dispatch) => {
		try {
			const response = await educationAPI.getSendFeedback(feedback);
			if (response.data.approve) {
				dispatch(setFeedbackApprove(response.data?.message?.textmsg));
			}
		} catch (error: any) {
			console.log(error.message);
		}
	};

export default education_Reducer;
